// extracted by mini-css-extract-plugin
module.exports = {"root":"_slug__root__ccBDe","exception":"_slug__exception__a4XNX","pages":"_slug__pages__LqosI"};